import {Injectable} from '@angular/core';
import {Response, Headers, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import { Invite } from '../models/invite';

@Injectable()
export class InvitePerformService {

  private inviteUrl = `${ environment.apiRoot }/perform-invite/`;

  constructor(private http: HttpAuth) { }

  public getPerformInvites(job_id: string, page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (job_id != null) {
      params.append('job_id', String(job_id));
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.inviteUrl, options)
      .map(this.extractData)
      .catch((error: any) => Observable.throw(error.json().meta || {message: 'server error', status: 0}));
  }

  public getPerformInviteByPerform(performId: string, page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('perform_id', String(performId));

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.inviteUrl, options)
      .map(this.extractData)
      .catch((error: any) => Observable.throw(error.json().meta || {message: 'server error', status: 0}));
  }

  public getPerformInvite(id: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('id', String(id));

    const options = new RequestOptions({search: params});

    return this.http.get(this.inviteUrl, options)
      .map(this.extractData)
      .catch((error: any) => Observable.throw(error.json().meta || {message: 'server error', status: 0}));
  }

  public postPerformInvite(job_id: string, perform_id: string): Observable<Invite> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {job_id: job_id, perform_id: perform_id};

    const options = new RequestOptions({search: params});

    return this.http.post(this.inviteUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postPerformReInvite(listInvitation: any, reinvite: boolean): Observable<Invite> {
    const params: URLSearchParams = new URLSearchParams();
    const body = {invitations: listInvitation, reinvite: reinvite};

    const options = new RequestOptions({search: params});

    return this.http.post(this.inviteUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/inviteperform.service.ts